module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"step":"Публикация","publish":"Опубликовать","pleaseWaitAiLoaderTextVoice":"Искусственный интеллект в процессе озвучивания вопросов для вашей вакансии. Ожидаемое время 3-5 минут, пожалуйста, подождите… При необходимости вы можете перейти в другие разделы. Вакансия будет доступна в разделе вакансий после завершения процесса подготовки.","vacancyCreated":"Вакансия создана"}}')
  delete Component.options._Ctor
}
